import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import accountUtilities from '@atom/utilities/accountUtilities';

import { Organization } from './TenantSelection';

import classes from './login.module.css';

const styles = {
  icon: {
    color: colors.brand.blue,
  },
};

interface Props {
  organization: Organization;
}

const TenantSelectionRow = ({ organization }: Props) => {
  const navigate = async () => {
    const protocol = window.location.protocol;

    const token = accountUtilities.getToken();

    window.location.href = `${protocol}//${organization.domain}/callback/${token}?tenant=${organization.name}`;
  };

  const organizationName = organization.name.toLocaleUpperCase();

  return (
    <div className={classes.tenantSelectionRowContainer} onClick={navigate}>
      <div className={classes.tenantSelectionIcon}>
        <Icon style={styles.icon}>business</Icon>
      </div>
      <div className={classes.tenantSelectionNameContainer}>
        <div className={classes.tenantSelectionName}>{organizationName}</div>
        <div className={classes.tenantSelectionDomain}>
          {organization.domain}
        </div>
      </div>
      <div className={classes.tenantNavigationButtonContainer}>
        <div className={classes.tenantSelectionButton}>continue</div>
      </div>
    </div>
  );
};

export default TenantSelectionRow;
